import React, { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Grid from '@mui/material/Grid2'
import Paper from '@mui/material/Paper'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { useParams } from 'react-router-dom'
import Container from '@mui/material/Container'
import { getData } from '../../api/indexedDBHandler'
import './TournamentOpen.css'
import ButtonMenuTournament from './ButtonMenuTournament'

const TournamentOpen = () => {
  const [tournament, setTournament] = useState(null)
  const [componentAllowed, setComponentAllowed] = useState([])
  const [componentBanned, setComponentBanned] = useState([])

  const { id } = useParams()
  console.log('Tournaments', id)

  useEffect(() => {
    const getTournament = async () => {
      const results = await getData('tournaments', 'id', id)
      if (results.length > 0) {
        const { value } = results[0]
        setTournament(value)
        console.log(value)
      }
    }
    getTournament()
  }, [id])

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))

  // Организатор Главный судья Главный секретарь Судья Судья - секретарь
  // function handleClick(event) {
  //   event.preventDefault()
  //   window.location.reload()
  // }

  useEffect(() => {
    if (!tournament) return

    const roles = tournament.roles
    const regexWeighing = /(Главный судья|Судья)/i
    const regexDraw =
      /(Главный судья|Судья|Главный секретарь|Судья - секретарь)/i
    const regexCommands =
      /(Организатор|Главный судья|Главный секретарь|Судья - секретарь)/i
    const regexDocumentation =
      /(Организатор|Главный судья|Главный секретарь|Судья - секретарь)/i
    const regexSettings = /(Главный судья|Организатор)/i
    const regexAccess = /(Главный судья|Организатор)/i
    const regexSocial = /(Организатор)/i
    const regexSponsors =
      /(Организатор|Главный судья|Главный секретарь|Судья - секретарь)/i

    const newComponentAllowed = []
    const newComponentBanned = []

    if (regexWeighing.test(roles)) {
      newComponentAllowed.push(
        <ButtonMenuTournament key="1" type="Weighing" allowed={true} id={id} />
      )
    } else {
      newComponentBanned.push(
        <ButtonMenuTournament
          key="11"
          type="Weighing"
          allowed={false}
          id={id}
        />
      )
    }

    if (regexDraw.test(roles))
      newComponentAllowed.push(
        <ButtonMenuTournament key="2" type="Draw" allowed={true} id={id} />
      )
    else
      newComponentBanned.push(
        <ButtonMenuTournament key="12" type="Draw" allowed={false} id={id} />
      )

    if (regexCommands.test(roles))
      newComponentAllowed.push(
        <ButtonMenuTournament key="3" type="Commands" allowed={true} id={id} />
      )
    else
      newComponentBanned.push(
        <ButtonMenuTournament
          key="13"
          type="Commands"
          allowed={false}
          id={id}
        />
      )

    if (regexDocumentation.test(roles))
      newComponentAllowed.push(
        <ButtonMenuTournament
          key="4"
          type="Documentation"
          allowed={true}
          id={id}
        />
      )
    else
      newComponentBanned.push(
        <ButtonMenuTournament
          key="14"
          type="Documentation"
          allowed={false}
          id={id}
        />
      )

    if (regexSettings.test(roles))
      newComponentAllowed.push(
        <ButtonMenuTournament key="5" type="Settings" allowed={true} id={id} />
      )
    else
      newComponentBanned.push(
        <ButtonMenuTournament
          key="15"
          type="Settings"
          allowed={false}
          id={id}
        />
      )

    if (regexAccess.test(roles))
      newComponentAllowed.push(
        <ButtonMenuTournament key="6" type="Access" allowed={true} id={id} />
      )
    else
      newComponentBanned.push(
        <ButtonMenuTournament key="16" type="Access" allowed={false} id={id} />
      )

    if (regexSocial.test(roles))
      newComponentAllowed.push(
        <ButtonMenuTournament key="7" type="Social" allowed={true} id={id} />
      )
    else
      newComponentBanned.push(
        <ButtonMenuTournament key="17" type="Social" allowed={false} id={id} />
      )

    if (regexSponsors.test(roles))
      newComponentAllowed.push(
        <ButtonMenuTournament key="8" type="Sponsors" allowed={true} id={id} />
      )
    else
      newComponentBanned.push(
        <ButtonMenuTournament
          key="18"
          type="Sponsors"
          allowed={false}
          id={id}
        />
      )

    setComponentAllowed(newComponentAllowed)
    setComponentBanned(newComponentBanned)

    console.log('Allowed Components:', newComponentAllowed)
    console.log('Banned Components:', newComponentBanned)
  }, [tournament])

  if (tournament)
    return (
      <Container sx={{ mb: 15 }}>
        <div
          role="presentation"
          // onClick={handleClick}
          style={{ textAlign: 'left', width: '100%' }}
        >
          <Breadcrumbs maxItems={2} aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/tournaments-list">
              Турниры
            </Link>

            <Typography sx={{ color: 'text.primary' }}>
              Редактирование
            </Typography>
          </Breadcrumbs>
        </div>
        <Typography variant="h6" gutterBottom color="black">
          {tournament.tournament_name}
        </Typography>
        <Grid container spacing={2} style={{ width: '100%' }}>
          {componentAllowed}
          {componentBanned}
        </Grid>
      </Container>
    )

  return null // Возвращать null пока данные tournament не загружены
}

export default TournamentOpen
